import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import Title from '../general/title'
import ReactTable from 'react-table'
import moment from 'moment'
import activities from '../../models/activities'

class ActivityTracker extends Component {

	constructor(props) {
		super(props)
		this.state = {
			name: "",
			id: +this.props.match.params.id,
		}
	}

	componentDidUpdate(prevProps) {
		if(prevProps.payload.salespeople !== this.props.payload.salespeople) {
			this.init()
		}
	}

	componentDidMount() {
		this.init()
	}

	init() {
		if(_.has(this.props.payload, `salespeople[${this.state.id}].firstName`)) {
			var obj = this.props.payload.salespeople[this.state.id]
			var name = `${obj.firstName} ${obj.lastName}`
			this.setState({
				'name': name
			})
		}
	}

	buildTable = () => {
		var ret = []

		if(_.has(this.props, 'payload.activity')) {
			this.props.payload.activity.forEach((r) => {
				if(this.state.id !== r.user) { return }
				var v = {}
				var icon
				console.log(r.type)
				switch(r.type) {
					case 'payload':
						icon = <i className="far fa-edit icon"></i>
						break
					case 'inputSale':
						icon = <i className='far fa-handshake-alt icon'></i>
						break
					case 'inputTraffic':
						icon = <i className='fas fa-walking icon'></i>
						break
					default:
						icon = <i className="far fa-edit icon"></i>
						break
				}
				v.activity = [icon, activities[r.type]]
				//v.activity = activities[r.type]
				v.date = r.addedDate

				ret.push(v)
			})
		}

		ret = _.sortBy(ret, 'date').reverse()
		console.log(ret)
		return ret
	}

	createTable = () => {
		const columns = [
			{
				Header: 'Activity',
				accessor: 'activity'
			},
			{
				Header: 'Date',
				accessor: 'date',
				Cell: props => moment.unix(props.value).format('M/D/YY, h:mm:ss a'),
				sort: 'desc'
			}
		]
		return (
			<div className="content">
				<ReactTable
					data={this.buildTable()}
					columns={columns}
					loadingText=""
					defaultPageSize={10}
					className="recentActivity__detailTable"
				/>
			</div>
		)
	}

	render() {

		return (
			<div className="sales">
				<Title title={`Activity Tracker for ${this.state.name}`} />
				{this.createTable()}
			</div>
		)
	}

}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ActivityTracker)